import { Box } from '@hover/blueprint';
import React from 'react';

import { useIsSharedView } from 'src/modules/renderings/hooks';
import { useFocusedView } from 'src/modules/renderings/hooks/useFocusedView';
import { useHeaderPortal } from 'src/modules/renderings/hooks/useHeaderPortal';
import { StyledNavBar } from 'src/shared/components/NavBar/StyledNavBar';
import { External as ExternalRoute, Route } from 'src/shared/route';

export const HEADER_HEIGHT = 72;

interface HeaderProps {
  routeKey?: keyof typeof Route | keyof typeof ExternalRoute;
}

const Routes = { ...ExternalRoute, ...Route };

const Header = ({ routeKey = 'ROOT' }: HeaderProps) => {
  const isSharedView = useIsSharedView();
  const { isFocusedView } = useFocusedView();
  const headerPortal = useHeaderPortal();

  const headerPortalDisplay = isFocusedView ? 'flex' : 'none';

  return (
    <StyledNavBar
      colorMode={isSharedView ? 'light' : 'dark'}
      redirectPath={Routes[routeKey].path}
    >
      <Box
        display={headerPortalDisplay}
        justifyContent="end"
        ref={headerPortal.ref}
      />
    </StyledNavBar>
  );
};

export { Header };
